import { memo, useEffect, useState } from "react"

import styles from "./AnimatedLogo.module.css"

export const AnimatedLogo = memo(() => {
	const [key, setKey] = useState(0)

	useEffect(() => {
		const interval = setInterval(() => {
			setKey((prevKey) => prevKey + 1)
		}, 5000) // Restart every 5 seconds (4s for animation + 1s pause)

		return () => clearInterval(interval)
	}, [])

	return (
		<div className={styles.logoContainer}>
			<svg
				key={key}
				viewBox="0 0 1773 1959"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ width: "100%", height: "auto" }}
				className={styles.logo}
			>
				{/* Triangle */}
				<path
					stroke="var(--base-a12)"
					d="M874.686 184.129L1199.82 435.367C949.58 345.306 806.392 346.596 549.555 435.367L874.686 184.129Z"
					className={styles.triangle}
				/>

				{/* Outer circle */}
				<path
					stroke="var(--base-a12)"
					d="M1469 1126.27C1469 1454.21 1203.15 1720.06 875.213 1720.06C547.274 1720.06 281.427 1454.21 281.427 1126.27C281.427 798.33 547.274 532.482 875.213 532.482C1203.15 532.482 1469 798.33 1469 1126.27Z"
					className={styles.outerCircle}
				/>

				{/* Inner circle */}
				<path
					stroke="var(--base-a12)"
					d="M1321.95 1126.27C1321.95 1372.99 1121.94 1573.01 875.213 1573.01C628.487 1573.01 428.477 1372.99 428.477 1126.27C428.477 879.543 628.487 679.532 875.213 679.532C1121.94 679.532 1321.95 879.543 1321.95 1126.27Z"
					className={styles.innerCircle}
				/>
			</svg>
		</div>
	)
})
AnimatedLogo.displayName = "AnimatedLogo"
